import { render, staticRenderFns } from "./CaveRewardsComponent.vue?vue&type=template&id=79a92abe&"
import script from "./CaveRewardsComponent.vue?vue&type=script&lang=js&"
export * from "./CaveRewardsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports